import { allPosts } from "../../../mocks/newsData";
import { useCMSPage } from "../../../context/CMSContext";

export default function NewsHero() {
  const featured = allPosts.find((p) => p.featured);
  const { data: newsCMS } = useCMSPage("news");
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const heroCMS: any = (newsCMS as any)?.hero ?? {};

  const badge      = heroCMS?.badge       ?? "Cleario News & Guides";
  const headline   = heroCMS?.headline    ?? "Waste wisdom.";
  const subheadline= heroCMS?.subheadline ?? "Tips, guides, company news, and industry updates from the Cleario team.";

  return (
    <section className="relative bg-cl-dark overflow-hidden pt-32 pb-16 md:pt-40 md:pb-20">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] rounded-full bg-cl-lime blur-[120px]" />
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full bg-cl-green blur-[100px]" />
      </div>

      <div className="relative max-w-screen-xl mx-auto px-6 lg:px-10">
        <div className="inline-flex items-center gap-2 bg-cl-lime rounded-full px-4 py-1.5 mb-6 thick-border cartoon-shadow-sm">
          <i className="ri-newspaper-line text-cl-dark text-xs"></i>
          <span className="text-cl-dark text-xs font-black uppercase tracking-widest">{badge}</span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div>
            <h1 className="text-4xl md:text-6xl font-black text-white leading-tight mb-4">
              {headline.split("\n")[0]}<br />
              <span className="text-cl-lime">{headline.split("\n")[1] ?? "No waffle."}</span>
            </h1>
            <p className="text-white/60 text-base md:text-lg font-semibold leading-relaxed mb-8 max-w-lg">
              {subheadline}
            </p>
          </div>

          {featured && (
            <div className="bg-white/10 backdrop-blur-sm border-2 border-white/20 rounded-2xl overflow-hidden">
              <img src={featured.image} alt={featured.title} className="w-full h-48 object-cover" />
              <div className="p-5">
                <span className="text-cl-lime text-xs font-black uppercase tracking-widest">{featured.category}</span>
                <h2 className="text-white font-black text-lg mt-1 mb-2 leading-tight">{featured.title}</h2>
                <p className="text-white/60 text-sm font-semibold leading-relaxed line-clamp-2">{featured.excerpt}</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
